import React, { Component } from 'react'
import Item from './Item'

class Sortable extends Component {
	render() {
		const { emptyItemUI, className } = this.props

		return (
			<div className={className}>
				{this.props?.data?.length ? (
					this.props?.data?.map?.((item, idx) => {
						const idField = this.props?.idField || 'id'
						const id = item[idField]

						return (
							<Item
								type={this.props.type || 'item'}
								accepts={
									this.props.accepts ||
									this.props.type || ['item', 'sectionPill']
								}
								key={`sortableItem-${id}`}
								id={`sortableItem-${id}`}
								item={item}
								idx={idx}
								index={idx}
								ItemUI={this.props.itemUI}
								DragHandle={this.props.dragHandle}
								onDrop={this.props.onDrop}
								moveItem={this.props.onDragOver || this.props.onNavigate}
								moveUp={this.props.moveUp}
								moveDown={this.props.moveDown}
								onDelete={this.props.onDelete}
							/>
						)
					})
				) : emptyItemUI ? (
					<emptyItemUI />
				) : (
					<div style={{ padding: 10, color: 'gray', textAlign: 'center' }}>
						Add a section
					</div>
				)}
			</div>
		)
	}
}

export default Sortable
